import { render, staticRenderFns } from "./portfolioBS.vue?vue&type=template&id=389e7a52"
import script from "./portfolioBS.vue?vue&type=script&lang=js"
export * from "./portfolioBS.vue?vue&type=script&lang=js"
import style0 from "./portfolioBS.vue?vue&type=style&index=0&id=389e7a52&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports